module.exports = __webpack_public_path__ + "img/exhaustPipe-2.4bbb4b51.jpg";